import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"

const Navbar = props => {
  function translate (text) {
    return props.t(text)
  }
  
  const [ui, setui] = useState(false)
  const [app, setapp] = useState(false)
  const [email, setemail] = useState(false)
  const [ecommerce, setecommerce] = useState(false)
  const [contact, setcontact] = useState(false)
  const [component, setcomponent] = useState(false)
  const [form, setform] = useState(false)
  const [table, settable] = useState(false)
  const [chart, setchart] = useState(false)
  const [icon, seticon] = useState(false)
  const [map, setmap] = useState(false)
  const [extra, setextra] = useState(false)
  const [invoice, setinvoice] = useState(false)
  const [auth, setauth] = useState(false)
  const [utility, setutility] = useState(false)

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props?.location?.pathname === items[i]?.pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })
  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="topnav">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard"
                  >
                    <i className="uil-home-alt me-2"></i>
                    {" "}{translate("Dashboard")}
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                      setui(!ui)
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="uil-flask me-2"></i>
                    {translate("UI Elements")} <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname(
                      "dropdown-menu mega-dropdown-menu dropdown-menu-left dropdown-mega-menu-xl",
                      { show: ui }
                    )}
                  >
                    <Row>
                      <Col lg={4}>
                        <div>
                          <Link to="#" className="dropdown-item">
                            {translate("Alerts")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Buttons")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Cards")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Carousel")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Dropdowns")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Grid")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Images")}
                          </Link>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Link to="#" className="dropdown-item">
                            {translate("Lightbox")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Modals")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Range Slider")}
                          </Link>
                          <Link
                            to="#"
                            className="dropdown-item"
                          >
                            {translate("Session Timeout")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Progress Bars")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Sweet-Alert")}
                          </Link>
                          <Link
                            to="#"
                            className="dropdown-item"
                          >
                            {translate("Tabs & Accordions")}
                          </Link>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Link to="#" className="dropdown-item">
                            {translate("Typography")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Video")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("General")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Colors")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Rating")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Notifications")}
                          </Link>
                          <Link to="#" className="dropdown-item">
                            {translate("Image Cropper")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault()
                      setapp(!app)
                    }}
                    className="nav-link dropdown-togglez arrow-none"
                  >
                    <i className="uil-apps me-2"></i>
                    {translate("Apps")} <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: app })}>
                    <Link to="#" className="dropdown-item">
                      {translate("Calendar")}
                    </Link>
                    <Link to="#" className="dropdown-item">
                      {translate("Chat")}
                    </Link>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setemail(!email)
                        }}
                      >
                        {translate("Email")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: email })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Inbox")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Read Email")}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setecommerce(!ecommerce)
                        }}
                      >
                        {translate(" Ecommerce")}{" "}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: ecommerce,
                        })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Products")}
                        </Link>
                        <Link
                          to="#-detail"
                          className="dropdown-item"
                        >
                          {translate("Product Detail")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Orders")}
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                        >
                          {translate("Customers")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Cart")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Checkout")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Shops")}
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                        >
                          {translate("Add Product")}
                        </Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setinvoice(!invoice)
                        }}
                      >
                        {translate("Invoices")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: invoice })}
                      >
                        <Link to="#" className="dropdown-item">{translate("Invoice List")}</Link>
                        <Link to="#" className="dropdown-item">{translate("Invoice Detail")}</Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setcontact(!contact)
                        }}
                      >
                        {translate("Contacts")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: contact,
                        })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("User Grid")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("User List")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Profile")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault()
                      setcomponent(!component)
                    }}
                  >
                    <i className="uil-layers me-2"></i>
                    {translate("Components")} <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu", { show: component })}
                  >
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setform(!form)
                        }}
                      >
                        {translate("Forms")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: form })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Basic Elements")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Layouts")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Validation")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Advanced")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Editors")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form File Upload")}{" "}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Xeditable")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Repeater")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Wizard")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Form Mask")}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          settable(!table)
                        }}
                      >
                        {translate("Tables")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: table })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Basic Table")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Data Table")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Responsive Table")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Editable Table")}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setchart(!chart)
                        }}
                      >
                        {translate("Charts")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: chart })}
                      >
                        <Link to="#" className="dropdown-item">
                          {" "}
                          {translate("Apex charts")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {" "}
                          {translate("Chartjs Chart")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {" "}
                          {translate("E Chart")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Jquery Knob")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {" "}
                          {translate("Sparkline Chart")}
                        </Link>

                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          seticon(!icon)
                        }}
                      >
                        {translate("Icons")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: icon })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Unicons")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Boxicons")}
                        </Link>
                        <Link
                          to="#"
                          className="dropdown-item"
                        >
                          {translate("Material Design")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Dripicons")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Font awesome")}{" "}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setmap(!map)
                        }}
                      >
                        {translate("Maps")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: map })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Google Maps")}{" "}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Vector Maps")}{" "}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Leaflet Maps")}{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="#"
                    onClick={e => {
                      e.preventDefault()
                      setextra(!extra)
                    }}
                  >
                    <i className="uil-copy me-2"></i>
                    {translate("Extra pages")} <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: extra })}>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault()
                          setauth(!auth)
                        }}
                      >
                        {translate("Authentication")}{" "}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: auth })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Login")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Register")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Recover Password")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Lock Screen")}
                        </Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        className="dropdown-item dropdown-toggle arrow-none"
                        to="#"
                        onClick={e => {
                          e.preventDefault()
                          setutility(!utility)
                        }}
                      >
                        {translate("Utility")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", {
                          show: utility,
                        })}
                      >
                        <Link to="#" className="dropdown-item">
                          {translate("Starter Page")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Maintenance")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Coming Soon")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Timeline")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("FAQs")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Pricing")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Error 404")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {translate("Error 500")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)